

import icon from  "assets/images/tale3-icon.png"

export const AppIcon=({onClick}:{onClick?:()=>void})=>{
    return <>
        <div  onClick={onClick} className="flex rounded-lg overflow-hidden  h-10 w-10 items-center justify-center  bg-primary">
            <img src={icon} alt="tale3-icon"  />
        </div>
    </>
}